export default __webpack_public_path__ + "static/mindMatcherOneLine-843dc24a8cee7f3e235591611b47823d.png";